import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {Stack, useTheme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {Legend, LegendItem} from '../../../../shared/components/Legend'
import {TogglePlanTypeButton} from '../../optimizerDetails/TogglePlanTypeButton'
import {useSelectedOptimizerPlan} from '../../SelectedOptimizerPlanProvider'

type OptimizerStockLevelsCardSummaryHeaderProps = {
  isCollapsed: boolean
}

export const OptimizerStockLevelsCardSummaryHeader: React.FC<
  OptimizerStockLevelsCardSummaryHeaderProps
> = ({isCollapsed}) => {
  const {t} = useTranslation()
  const {spacing, palette} = useTheme()

  const {selectedInTableScheduleId, visibleScheduleId} = useSelectedOptimizerPlan()

  const isOptimizedPlanSelected = selectedInTableScheduleId !== undefined
  const isProductionPlanToggleActive = visibleScheduleId === undefined

  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      {!isCollapsed && (
        <Legend testId="silo_levels_legend">
          <LegendItem
            label={t(
              isOptimizedPlanSelected && isProductionPlanToggleActive
                ? 'optimizer.currentPlan'
                : 'optimizer.selectedPlan'
            )}
            indicator={{
              style: {backgroundColor: palette.primary.light},
              variant: 'circle'
            }}
          />
          {isOptimizedPlanSelected && !isProductionPlanToggleActive && (
            <LegendItem
              label={t('optimizer.currentPlan')}
              indicator={{
                style: {backgroundColor: customThemeConstants().palette.accent1},
                variant: 'circle'
              }}
            />
          )}
          <LegendItem label={t('optimizer.minLevel')}>
            <svg width={spacing(4)} height="3px">
              <line
                x1={0}
                x2={30}
                strokeWidth={1}
                y1={1}
                y2={1}
                stroke={palette.error.light}
                strokeDasharray="8,5"
              />
            </svg>
          </LegendItem>
        </Legend>
      )}
      <TogglePlanTypeButton />
    </Stack>
  )
}
